import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "nav-tabs" }
const _hoisted_2 = { class: "nav-tabs__list" }
const _hoisted_3 = {
  key: 1,
  class: "nav-tabs__link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.key || i,
          ref_for: true,
          ref: el => _ctx.setListRef(el, i),
          class: _normalizeClass([{
					'is-active': item.is_active,
					'is-disabled': item.is_disabled,
				}, "nav-tabs__item"])
        }, [
          (!item.is_disabled)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: item.to,
                class: "nav-tabs__link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.label), 1))
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", {
      ref: "pill",
      class: _normalizeClass(["nav-tabs__pill", { 'is-hidden': !_ctx.isPillVisible }]),
      "aria-hidden": ""
    }, null, 2)
  ]))
}